import { all } from 'redux-saga/effects';
import initdatasaga from './init-data';
import profilesaga from './profile';
import devicesaga from './device';
import kycsaga from './kyc';

export default function* rootsaga() {
  yield all([initdatasaga(), profilesaga(), devicesaga(), kycsaga()]);
}
